/* Base translations · FS mapping / chart-of-accounts mapping — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): fsMappingPage, fsMappingImport, fsMappingReview, coaMapping, fsCombobox. */
export const I18N_BASE_FS_MAPPING = {
  en: {
    fsMappingPage: {
      back: "Back to Financial Statements",
      title: "Financial Statements — Mapping",
      framework: "Framework:",
      stats: {
        total: "Accounts total",
        mapped: "Fully mapped",
        unmapped: "Unmapped",
        pending: "AI/hint pending",
      },
      coverage: {
        heading: "Cash-flow sub-note tagging —",
        needTagging: "{n} still need manual tagging",
        autoInferred: "{n} auto-inferred (Partner review)",
        body: "Cash-flow correctness (H9, M2, unwinding split, deferred-tax strip, ECL / impairment / depreciation exclusions) depends on these sub-note tags. Rows marked {autoBadge} were inferred from the account name; confirm or override before signoff.",
        autoBadge: "Auto — review",
        untaggedSuffix: "· {n} untagged",
        autoSuffix: "· {n} auto",
        rerun: "Re-run inference",
        reinferredToast: "Re-inferred {n} row(s); {left} still need manual review.",
        reinferFailed: "Re-inference failed",
      },
      accounts: "Accounts",
      searchPlaceholder: "Search account…",
      filters: {
        all: "All accounts",
        unmapped: "Unmapped only",
        mapped: "Mapped only",
        noteMissing: "Note line missing",
        hasSuggestion: "Has AI/hint suggestion",
      },
      buttons: {
        suggestAllFs: "AI Suggest All (FS Mapping)",
        suggestNotes: "AI Suggest Note Mapping",
        reviewQueue: "Review Queue",
        applyAllFs: "Apply-All ≥ {pct}% FS",
        applyAllNotes: "Apply-All ≥ {pct}% Notes",
        downloadTemplate: "Download Template",
        copyPriorYear: "Copy from prior year",
        importMapping: "Import Mapping",
        clearFs: "Clear FS Mapping",
        clearNote: "Clear Note Mapping",
        addCustomFs: "Add custom FS line",
        applyAllSuggestions: "Apply all {n} suggestions",
        bulkSet: "Bulk-set {n} rows",
      },
      cols: {
        code: "Code",
        account: "Account",
        fsMapping: "FS Mapping",
        noteMapping: "Note Mapping",
        actions: "Actions",
      },
      emptyNoAccounts: "No accounts yet — upload a GL or TB first.",
      emptyNoMatches: "No rows match this filter.",
      unmappedBadge: "Unmapped",
      hintPrefix: "hint: {hint}",
      aiSuggest: "AI Suggest",
      queue: {
        title: "AI Review Queue",
        confGate: "Confidence gate:",
        close: "Close",
        dismiss: "Dismiss ({n})",
        approve: "Approve ({n})",
      },
      prior: {
        title: "Copy mapping from prior year",
        desc: "Reuse the mapping decisions from a prior engagement for {client}. Rows are matched by account code (or account name as fallback).",
        loading: "Loading candidates…",
        empty: "No prior-year engagements found for this client with mapped accounts. Complete a mapping on another engagement for the same client first.",
        mappedSuffix: " mapped",
        overwrite: "Overwrite existing mappings on this engagement",
        cancel: "Cancel",
        apply: "Copy mapping",
      },
      bulk: {
        title: "Apply mapping to {n}",
        fsCode: "FS mapping code",
        fsBlankHint: "Leave blank to only change the note line.",
        noteCode: "Note mapping",
        cancel: "Cancel",
        apply: "Apply",
      },
      note: {
        pickFsFirst: "pick FS line first",
        picker: "— pick note line —",
        pending: "pending",
        customBadge: "Custom",
        searchPlaceholder: "Search note…",
        addCustom: "Add custom note line",
        addCustomTailored: "tailored to this client / industry",
        empty: "No note matches.",
        suggestionHeading: "AI / hint suggestion",
        clearHeading: "Clear",
        clear: "Clear",
        noteHeading: "Note {n}",
        confirmWrite: "Confirm write:",
        confirmClear: "Confirm write: clear",
        cancel: "Cancel",
        apply: "Apply",
        chipReview: "· review",
      },
      customFs: {
        title: "Add custom FS line",
        intro: "Available to every user at your firm. Codes are auto-assigned in the reserved 90-99 slot for the placement's block and are visible only to your firm — never shared across tenants.",
        lineItem: "Line item name",
        linePlaceholder: "e.g. Decommissioning provision — oilfield assets",
        placement: "Placement",
        placements: {
          ncAssets: "SFP non-current assets",
          curAssets: "SFP current assets",
          equity: "SFP equity",
          ncLiab: "SFP non-current liabilities",
          curLiab: "SFP current liabilities",
          pl: "P&L",
        },
        hints: {
          ncAssets: "non-current assets → 11xx block, code 1190-1199",
          curAssets: "current assets → 12xx block, code 1290-1299",
          equity: "equity → 21xx block, code 2190-2199",
          ncLiab: "non-current liab. → 31xx block, code 3190-3199",
          curLiab: "current liab. → 32xx block, code 3290-3299",
          pl: "P&L → block picked from Income/Expense + IFRS 18 category",
        },
        incVsExp: "Income vs Expense",
        pickOne: "Pick one",
        income: "Income (4xxx)",
        expense: "Expense (5xxx)",
        ifrs18cat: "IFRS 18 category",
        operating: "Operating (OP)",
        investing: "Investing (INV)",
        financing: "Financing (FIN)",
        tax: "Tax (TAX)",
        cancel: "Cancel",
        submit: "Create custom line",
        createdToast: "Custom FS code {code} created",
        createFailed: "Create failed",
      },
      customNote: {
        title: "Add custom note line",
        intro: "Can't find the right note? Add one tailored to this client or industry. Codes are auto-assigned (rooted {rootedCode} under an FS line, or cross-cutting {crossCode}) and visible only to your firm.",
        titleField: "Title",
        titlePlaceholder: "e.g. Loyalty programme deferred revenue",
        descRequired: "Description",
        descHint: "(min 15 characters — so another auditor can understand it later)",
        descPlaceholder: "What this note covers and why it doesn't fit an existing code.",
        rootUnder: "Root this note under an FS line",
        rootCode: "Root FS code",
        pickFs: "Pick FS code",
        autoAssignHint: "Auto-assigns code {code}.80..99 within your firm.",
        cancel: "Cancel",
        submit: "Create custom note",
        createdToast: "Custom note {code} created",
      },
      toasts: {
        filteredFs: "Filtered to FS code {code} — Fix Now from Notes tab.",
        jumpedAccount: "Jumped to account {code} — map it to the correct FS head.",
        selectAtLeastOne: "Select at least one row.",
        approvedFromQueue: "Approved {n} from Review Queue",
        approveFailed: "Approve failed",
        selectAtLeastOneDismiss: "Select at least one row to dismiss.",
        dismissedSuffix: "— won't be shown again",
        dismissFailed: "Dismiss failed",
        appliedAllHigh: "Applied {n} ≥ {pct}%",
        appliedSkipped: "· {skipped} skipped (low)",
        applyAllFailed: "Apply-all failed",
        loadPriorFailed: "Failed to load prior-year engagements",
        pickPriorFirst: "Pick a prior-year engagement first.",
        copiedPrior: "Copied FY{fy}: {rows} updated · {fs} FS, {note} note",
        copiedKept: "· {n} kept as-is ",
        copiedUnmatched: "· {n} unmatched",
        priorCopyFailed: "Prior-year copy failed",
        loadMappingFailed: "Failed to load mapping",
        mapped: "Mapped {acc} → {code}",
        clearedMapping: "Mapping cleared",
        saveFailed: "Save failed",
        suggested: "Suggested {code} ({pct}% · {source})",
        aiCouldNotSuggest: "AI could not suggest a code — please pick manually",
        aiSuggestFailed: "AI suggest failed",
        aiPartial: "AI suggested FS Mapping for {n} of {c} accounts — {u} could not be classified with confidence. Filter to \"Unmapped\" to review these manually.",
        aiAll: "AI suggested FS Mapping for all {n} unmapped accounts — review chips and Apply.",
        aiNotesPartial: "AI suggested Note Mapping for {n} of {c} accounts — {u} could not be classified. Review these manually.",
        aiNotesAll: "AI suggested Note Mapping for all {n} accounts — review chips and Apply.",
        aiNoteFailed: "AI Note suggest failed",
        templateFailed: "Template download failed",
        parseFailed: "Failed to parse or validate file",
        importApplied: "Import applied · {n} updated",
        importApplyFailed: "Import apply failed",
        noPending: "No pending suggestions",
        applyConfirm: "Apply {n} to the Chart of Accounts?",
        applied: "Applied {n}",
        bulkApplyFailed: "Bulk apply failed",
        noRowsInView: "No rows in view to clear",
        clearConfirm: "Clear {label} for {n}? This cannot be undone.",
        cleared: "{label} cleared on {n}",
        clearFailed: "{label} clear failed",
        pickCodeFirst: "Pick a code first",
        selectRowsFirst: "Select rows first",
        appliedTo: "Applied to {n}",
      },
      labels: {
        fs: "FS Mapping",
        note: "Note Mapping",
      },
    },
    fsMappingImport: {
      validRows: "Valid rows",
      errors: "Errors",
      matched: "Accounts matched",
      skipped: "Rows that will be skipped:",
      code: "Code",
      name: "Name",
      fsBeforeAfter: "FS: before → after",
      noteBeforeAfter: "Note: before → after",
    },
    fsMappingReview: {
      lowFirst: "Lowest confidence first",
      highFirst: "Highest confidence first",
      suggested: "Suggested",
      confidence: "Confidence",
      rationale: "Rationale",
    },
    coaMapping: {
      title: "Chart of Accounts mapping",
      descPre: "Every TB/GL account gets a ",
      descMajorBold: "Major Category",
      descAnd: " and a ",
      descMappingBold: "Mapping",
      descPost: " from the master IFRS taxonomy. Auto values are editable — the engine only suggests.",
      unmappedBadge: "{n} unmapped — FS blocked",
      applySelected: "Apply to {n} selected",
      aiSuggestBtn: "AI suggest ({n})",
      filterAll: "All rows",
      filterUnmapped: "Unmapped only",
      filterAuto: "Auto-mapped",
      filterManual: "Manually mapped",
      template: "Template",
      colCode: "Code",
      colRawName: "Raw Account Name",
      colMajor: "Major Category",
      colMapping: "Mapping",
      colSource: "Source",
      colFsMapping: "FS Mapping",
      colNoteMapping: "Note Mapping",
      colNoteRef: "Note Reference",
      editLink: "Edit ↗",
      noAccountsYet: "No accounts yet — upload a GL or TB.",
      noRowsMatch: "No rows match this filter.",
      selectDash: "— select —",
      pickCategoryFirst: "pick category first",
      derivedTooltip: "Derived from FS Mapping {code}. Edit on the FS Mapping page.",
      derivedLink: "derived ↗",
      unmappedSet: "Unmapped — set",
      autoReviewTooltip: "Auto-inferred from account name — Partner review recommended",
      autoReview: "Auto — review",
      noteRefPh: "e.g. Note 5",
      toastMappingSaved: "Mapping saved",
      toastSaveFail: "Save failed",
      toastPickCategoryRow: "Pick a Major Category, Mapping, and at least one row",
      toastAppliedRows: "Applied to {rows}",
      toastBulkFailed: "Bulk apply failed",
      toastNoSuggestions: "No suggestions",
      toastAiSuggestFail: "AI suggest failed",
      toastAiWarning: "AI suggested for {ok} of {total} accounts — {left} could not be classified. Review those manually.",
      toastNothingPicked: "Nothing picked",
      toastApplied: "Applied {n}",
      toastNoteSaved: "Note ref saved",
      bulkDialogTitle: "Apply mapping to {rows}",
      bulkDialogDescPre: "Pick a Major Category first, then a Mapping. Rows that were auto-mapped will be flipped to ",
      bulkDialogDescBold: "Manual",
      bulkDialogDescPost: ".",
      majorCategoryLabel: "Major Category",
      mappingLabel: "Mapping",
      pickDash: "— pick —",
      cancel: "Cancel",
      applying: "Applying…",
      applyToN: "Apply to {n}",
      aiDialogTitle: "AI mapping suggestions",
      aiDialogDesc: "The AI assistant proposed a Major Category + Mapping for each unmapped account. Rows with confidence ≥ 70% are pre-selected. Untick anything you disagree with.",
      classifying: "Classifying…",
      noSuggestionsReturned: "No suggestions returned.",
      aiColAccount: "Account",
      aiColSuggested: "Suggested",
      aiColConfidence: "Confidence",
      aiApplyBtn: "Apply {n}",
    },
    fsCombobox: {
      placement: {
        nonCurrentAssets: "Non-current assets",
        currentAssets: "Current assets",
        heldForSale: "Held-for-sale",
        equity: "Equity",
        nonCurrentLiabilities: "Non-current liabilities",
        currentLiabilities: "Current liabilities",
        profitOrLoss: "Profit or Loss",
      },
      pending: "pending",
      pickLine: "— pick statement line —",
      searchPlaceholder: "Search line, code or placement…",
      noMatch: "No line matches.",
      aiHint: "AI / hint suggestion",
      clear: "Clear",
      clearMapping: "Clear mapping",
      confirmWrite: "Confirm write:",
      confirmClear: "Confirm write: clear mapping",
      apply: "Apply",
      review: "review",
    },
  },
  ar: {
    fsMappingPage: {
      back: "العودة إلى القوائم المالية",
      title: "القوائم المالية — التعيين",
      framework: "الإطار:",
      stats: {
        total: "إجمالي الحسابات",
        mapped: "معيَّنة بالكامل",
        unmapped: "غير معيَّنة",
        pending: "بانتظار الذكاء الاصطناعي/التلميح",
      },
      coverage: {
        heading: "وسم الإيضاحات الفرعية للتدفق النقدي —",
        needTagging: "{n} لا تزال تحتاج وسماً يدوياً",
        autoInferred: "{n} تم استنتاجها تلقائياً (مراجعة الشريك)",
        body: "تعتمد صحة التدفق النقدي (H9, M2، تقسيم الفك، شريط الضريبة المؤجلة، استبعادات ECL / انخفاض القيمة / الاستهلاك) على هذه الوسوم الفرعية. الصفوف الموسومة {autoBadge} تم استنتاجها من اسم الحساب؛ أكِّدها أو تجاوزها قبل التوقيع.",
        autoBadge: "تلقائي — راجع",
        untaggedSuffix: "· {n} غير موسومة",
        autoSuffix: "· {n} تلقائي",
        rerun: "إعادة تشغيل الاستنتاج",
        reinferredToast: "تمت إعادة استنتاج {n} صف؛ {left} لا تزال تحتاج مراجعة يدوية.",
        reinferFailed: "فشل إعادة الاستنتاج",
      },
      accounts: "الحسابات",
      searchPlaceholder: "ابحث عن حساب…",
      filters: {
        all: "كل الحسابات",
        unmapped: "غير المعيَّنة فقط",
        mapped: "المعيَّنة فقط",
        noteMissing: "سطر الإيضاح مفقود",
        hasSuggestion: "يوجد اقتراح ذكاء اصطناعي/تلميح",
      },
      buttons: {
        suggestAllFs: "اقتراح ذكاء اصطناعي للكل (تعيين FS)",
        suggestNotes: "اقتراح ذكاء اصطناعي لتعيين الإيضاحات",
        reviewQueue: "قائمة المراجعة",
        applyAllFs: "تطبيق الكل ≥ {pct}% FS",
        applyAllNotes: "تطبيق الكل ≥ {pct}% إيضاحات",
        downloadTemplate: "تنزيل النموذج",
        copyPriorYear: "نسخ من السنة السابقة",
        importMapping: "استيراد التعيين",
        clearFs: "مسح تعيين FS",
        clearNote: "مسح تعيين الإيضاحات",
        addCustomFs: "إضافة سطر FS مخصص",
        applyAllSuggestions: "تطبيق كل الاقتراحات ({n})",
        bulkSet: "تعيين جماعي لـ {n} صف",
      },
      cols: {
        code: "الرمز",
        account: "الحساب",
        fsMapping: "تعيين FS",
        noteMapping: "تعيين الإيضاح",
        actions: "إجراءات",
      },
      emptyNoAccounts: "لا توجد حسابات بعد — استورد أستاذاً أو ميزان مراجعة أولاً.",
      emptyNoMatches: "لا توجد صفوف تطابق هذا المرشح.",
      unmappedBadge: "غير معيَّنة",
      hintPrefix: "تلميح: {hint}",
      aiSuggest: "اقتراح AI",
      queue: {
        title: "قائمة مراجعة الذكاء الاصطناعي",
        confGate: "بوابة الثقة:",
        close: "إغلاق",
        dismiss: "تجاهل ({n})",
        approve: "اعتماد ({n})",
      },
      prior: {
        title: "نسخ التعيين من السنة السابقة",
        desc: "أعد استخدام قرارات التعيين من مهمة سابقة لـ {client}. تتم مطابقة الصفوف حسب رمز الحساب (أو اسم الحساب كخيار احتياطي).",
        loading: "جاري تحميل المرشحين…",
        empty: "لم يتم العثور على مهام السنة السابقة لهذا العميل مع حسابات معيَّنة. أكمل التعيين على مهمة أخرى لنفس العميل أولاً.",
        mappedSuffix: " معيَّنة",
        overwrite: "استبدال التعيينات الحالية في هذه المهمة",
        cancel: "إلغاء",
        apply: "نسخ التعيين",
      },
      bulk: {
        title: "تطبيق التعيين على {n}",
        fsCode: "رمز تعيين FS",
        fsBlankHint: "اترك فارغاً لتغيير سطر الإيضاح فقط.",
        noteCode: "تعيين الإيضاح",
        cancel: "إلغاء",
        apply: "تطبيق",
      },
      note: {
        pickFsFirst: "اختر سطر FS أولاً",
        picker: "— اختر سطر الإيضاح —",
        pending: "معلَّق",
        customBadge: "مخصص",
        searchPlaceholder: "ابحث عن إيضاح…",
        addCustom: "إضافة سطر إيضاح مخصص",
        addCustomTailored: "مصمَّم لهذا العميل / القطاع",
        empty: "لا يوجد إيضاح مطابق.",
        suggestionHeading: "اقتراح ذكاء اصطناعي/تلميح",
        clearHeading: "مسح",
        clear: "مسح",
        noteHeading: "إيضاح {n}",
        confirmWrite: "تأكيد الكتابة:",
        confirmClear: "تأكيد الكتابة: مسح",
        cancel: "إلغاء",
        apply: "تطبيق",
        chipReview: "· راجع",
      },
      customFs: {
        title: "إضافة سطر FS مخصص",
        intro: "متاح لكل مستخدم في شركتك. يتم تعيين الرموز تلقائياً في الفتحة المحجوزة 90-99 لكتلة الوضع، ومرئية فقط لشركتك — لا تُشارك عبر المستأجرين.",
        lineItem: "اسم البند",
        linePlaceholder: "مثال: مخصص إيقاف التشغيل — أصول حقول النفط",
        placement: "الوضع",
        placements: {
          ncAssets: "SFP الأصول غير المتداولة",
          curAssets: "SFP الأصول المتداولة",
          equity: "SFP حقوق الملكية",
          ncLiab: "SFP الالتزامات غير المتداولة",
          curLiab: "SFP الالتزامات المتداولة",
          pl: "الأرباح والخسائر",
        },
        hints: {
          ncAssets: "الأصول غير المتداولة ← كتلة 11xx، الرمز 1190-1199",
          curAssets: "الأصول المتداولة ← كتلة 12xx، الرمز 1290-1299",
          equity: "حقوق الملكية ← كتلة 21xx، الرمز 2190-2199",
          ncLiab: "الالتزامات غير المتداولة ← كتلة 31xx، الرمز 3190-3199",
          curLiab: "الالتزامات المتداولة ← كتلة 32xx، الرمز 3290-3299",
          pl: "الأرباح والخسائر ← كتلة تُختار بناءً على الدخل/المصروف + فئة IFRS 18",
        },
        incVsExp: "دخل مقابل مصروف",
        pickOne: "اختر واحداً",
        income: "دخل (4xxx)",
        expense: "مصروف (5xxx)",
        ifrs18cat: "فئة IFRS 18",
        operating: "تشغيلي (OP)",
        investing: "استثماري (INV)",
        financing: "تمويلي (FIN)",
        tax: "ضريبي (TAX)",
        cancel: "إلغاء",
        submit: "إنشاء السطر المخصص",
        createdToast: "تم إنشاء رمز FS المخصص {code}",
        createFailed: "فشل الإنشاء",
      },
      customNote: {
        title: "إضافة سطر إيضاح مخصص",
        intro: "لا تجد الإيضاح المناسب؟ أضف واحداً مصمَّماً لهذا العميل أو القطاع. تُخصَّص الرموز تلقائياً (جذرية {rootedCode} تحت سطر FS، أو شاملة {crossCode}) ومرئية فقط لشركتك.",
        titleField: "العنوان",
        titlePlaceholder: "مثال: إيرادات مؤجلة لبرنامج الولاء",
        descRequired: "الوصف",
        descHint: "(15 حرفاً على الأقل — ليتمكن مدقق آخر من فهمه لاحقاً)",
        descPlaceholder: "ما الذي يغطيه هذا الإيضاح ولماذا لا يناسب رمزاً موجوداً.",
        rootUnder: "جذر هذا الإيضاح تحت سطر FS",
        rootCode: "رمز FS الجذري",
        pickFs: "اختر رمز FS",
        autoAssignHint: "يُخصِّص تلقائياً الرمز {code}.80..99 داخل شركتك.",
        cancel: "إلغاء",
        submit: "إنشاء الإيضاح المخصص",
        createdToast: "تم إنشاء الإيضاح المخصص {code}",
      },
      toasts: {
        filteredFs: "تمت التصفية إلى رمز FS {code} — أصلح الآن من تبويب الإيضاحات.",
        jumpedAccount: "الانتقال إلى حساب {code} — عيّنه إلى الرأس الصحيح لـ FS.",
        selectAtLeastOne: "اختر صفاً واحداً على الأقل.",
        approvedFromQueue: "تم اعتماد {n} من قائمة المراجعة",
        approveFailed: "فشل الاعتماد",
        selectAtLeastOneDismiss: "اختر صفاً واحداً على الأقل للتجاهل.",
        dismissedSuffix: "— لن تُعرض مرة أخرى",
        dismissFailed: "فشل التجاهل",
        appliedAllHigh: "تم تطبيق {n} ≥ {pct}%",
        appliedSkipped: "· {skipped} تم تخطيها (منخفض)",
        applyAllFailed: "فشل تطبيق الكل",
        loadPriorFailed: "تعذر تحميل مهام السنة السابقة",
        pickPriorFirst: "اختر مهمة سنة سابقة أولاً.",
        copiedPrior: "تم نسخ السنة المالية {fy}: تم تحديث {rows} · {fs} FS، {note} إيضاح",
        copiedKept: "· تم الإبقاء على {n} كما هي ",
        copiedUnmatched: "· {n} غير مطابقة",
        priorCopyFailed: "فشل نسخ السنة السابقة",
        loadMappingFailed: "تعذر تحميل التعيين",
        mapped: "تم تعيين {acc} ← {code}",
        clearedMapping: "تم مسح التعيين",
        saveFailed: "فشل الحفظ",
        suggested: "الاقتراح {code} ({pct}% · {source})",
        aiCouldNotSuggest: "لم يستطع الذكاء الاصطناعي اقتراح رمز — اختر يدوياً من فضلك",
        aiSuggestFailed: "فشل اقتراح الذكاء الاصطناعي",
        aiPartial: "اقترح الذكاء الاصطناعي تعيين FS لـ {n} من أصل {c} حساب — {u} تعذر تصنيفها بثقة. صفِّ إلى \"غير المعيَّنة\" لمراجعتها يدوياً.",
        aiAll: "اقترح الذكاء الاصطناعي تعيين FS لجميع الحسابات غير المعيَّنة الـ {n} — راجع الشرائح واضغط تطبيق.",
        aiNotesPartial: "اقترح الذكاء الاصطناعي تعيين الإيضاح لـ {n} من أصل {c} حساب — {u} تعذر تصنيفها. راجعها يدوياً.",
        aiNotesAll: "اقترح الذكاء الاصطناعي تعيين الإيضاح لجميع الحسابات الـ {n} — راجع الشرائح واضغط تطبيق.",
        aiNoteFailed: "فشل اقتراح الذكاء الاصطناعي للإيضاحات",
        templateFailed: "فشل تنزيل النموذج",
        parseFailed: "فشل تحليل الملف أو التحقق منه",
        importApplied: "تم تطبيق الاستيراد · تم تحديث {n}",
        importApplyFailed: "فشل تطبيق الاستيراد",
        noPending: "لا توجد اقتراحات معلَّقة",
        applyConfirm: "تطبيق {n} على شجرة الحسابات؟",
        applied: "تم تطبيق {n}",
        bulkApplyFailed: "فشل التطبيق الجماعي",
        noRowsInView: "لا توجد صفوف في العرض للمسح",
        clearConfirm: "مسح {label} لـ {n}؟ لا يمكن التراجع.",
        cleared: "تم مسح {label} على {n}",
        clearFailed: "فشل مسح {label}",
        pickCodeFirst: "اختر رمزاً أولاً",
        selectRowsFirst: "اختر صفوفاً أولاً",
        appliedTo: "تم التطبيق على {n}",
      },
      labels: {
        fs: "تعيين FS",
        note: "تعيين الإيضاح",
      },
    },
    fsMappingImport: {
      validRows: "الصفوف الصالحة",
      errors: "الأخطاء",
      matched: "الحسابات المُطابقة",
      skipped: "الصفوف التي سيتم تخطيها:",
      code: "الرمز",
      name: "الاسم",
      fsBeforeAfter: "التصنيف: قبل ← بعد",
      noteBeforeAfter: "الملاحظة: قبل ← بعد",
    },
    fsMappingReview: {
      lowFirst: "الأقل ثقة أولاً",
      highFirst: "الأعلى ثقة أولاً",
      suggested: "الاقتراح",
      confidence: "الثقة",
      rationale: "المبرر",
    },
    coaMapping: {
      title: "تخطيط دليل الحسابات",
      descPre: "يحصل كل حساب في ميزان المراجعة/الأستاذ العام على ",
      descMajorBold: "فئة رئيسية",
      descAnd: " و",
      descMappingBold: "تخطيط",
      descPost: " من تصنيف IFRS الرئيسي. القيم التلقائية قابلة للتعديل — يقتصر المحرك على الاقتراح.",
      unmappedBadge: "{n} غير مربوطة — القوائم المالية محظورة",
      applySelected: "تطبيق على {n} محدد",
      aiSuggestBtn: "اقتراح الذكاء الاصطناعي ({n})",
      filterAll: "كل الصفوف",
      filterUnmapped: "غير المربوطة فقط",
      filterAuto: "المربوطة تلقائيًا",
      filterManual: "المربوطة يدويًا",
      template: "قالب",
      colCode: "الكود",
      colRawName: "اسم الحساب الأصلي",
      colMajor: "الفئة الرئيسية",
      colMapping: "التخطيط",
      colSource: "المصدر",
      colFsMapping: "تخطيط القوائم المالية",
      colNoteMapping: "تخطيط الإيضاح",
      colNoteRef: "مرجع الإيضاح",
      editLink: "تعديل ↗",
      noAccountsYet: "لا توجد حسابات بعد — قم برفع الأستاذ العام أو ميزان المراجعة.",
      noRowsMatch: "لا توجد صفوف مطابقة لهذا الفلتر.",
      selectDash: "— اختر —",
      pickCategoryFirst: "اختر الفئة أولاً",
      derivedTooltip: "مستمد من تخطيط القوائم المالية {code}. عدّل من صفحة تخطيط القوائم المالية.",
      derivedLink: "مستمد ↗",
      unmappedSet: "غير مربوط — حدد",
      autoReviewTooltip: "استنتاج تلقائي من اسم الحساب — يُنصح بمراجعة الشريك",
      autoReview: "تلقائي — راجع",
      noteRefPh: "مثال: إيضاح 5",
      toastMappingSaved: "تم حفظ التخطيط",
      toastSaveFail: "فشل الحفظ",
      toastPickCategoryRow: "اختر فئة رئيسية وتخطيطًا وصفًا واحدًا على الأقل",
      toastAppliedRows: "تم التطبيق على {rows}",
      toastBulkFailed: "فشل التطبيق بالجملة",
      toastNoSuggestions: "لا توجد اقتراحات",
      toastAiSuggestFail: "فشل اقتراح الذكاء الاصطناعي",
      toastAiWarning: "اقترح الذكاء الاصطناعي لـ {ok} من {total} حسابات — تعذّر تصنيف {left}. راجعها يدويًا.",
      toastNothingPicked: "لم يتم اختيار شيء",
      toastApplied: "تم التطبيق على {n}",
      toastNoteSaved: "تم حفظ مرجع الإيضاح",
      bulkDialogTitle: "تطبيق التخطيط على {rows}",
      bulkDialogDescPre: "اختر فئة رئيسية أولاً، ثم تخطيطًا. الصفوف المربوطة تلقائيًا ستتحول إلى ",
      bulkDialogDescBold: "يدوي (متجاوز)",
      bulkDialogDescPost: ".",
      majorCategoryLabel: "الفئة الرئيسية",
      mappingLabel: "التخطيط",
      pickDash: "— اختر —",
      cancel: "إلغاء",
      applying: "جاري التطبيق…",
      applyToN: "تطبيق على {n}",
      aiDialogTitle: "اقتراحات الذكاء الاصطناعي للتخطيط",
      aiDialogDesc: "اقترح المساعد الذكي فئة رئيسية وتخطيطًا لكل حساب غير مربوط. الصفوف بثقة ≥ 70% محددة مسبقًا. أزل التحديد عن أي شيء لا توافق عليه.",
      classifying: "جاري التصنيف…",
      noSuggestionsReturned: "لم تُرجع أي اقتراحات.",
      aiColAccount: "الحساب",
      aiColSuggested: "المقترح",
      aiColConfidence: "الثقة",
      aiApplyBtn: "تطبيق {n}",
    },
    fsCombobox: {
      placement: {
        nonCurrentAssets: "الأصول غير المتداولة",
        currentAssets: "الأصول المتداولة",
        heldForSale: "محتفظ به للبيع",
        equity: "حقوق الملكية",
        nonCurrentLiabilities: "الالتزامات غير المتداولة",
        currentLiabilities: "الالتزامات المتداولة",
        profitOrLoss: "الأرباح والخسائر",
      },
      pending: "قيد الانتظار",
      pickLine: "— اختر بند القوائم —",
      searchPlaceholder: "ابحث بالسطر أو الرمز أو المكان…",
      noMatch: "لا يوجد سطر مطابق.",
      aiHint: "اقتراح الذكاء الاصطناعي / تلميح",
      clear: "مسح",
      clearMapping: "مسح التصنيف",
      confirmWrite: "تأكيد الكتابة:",
      confirmClear: "تأكيد الكتابة: مسح التصنيف",
      apply: "تطبيق",
      review: "مراجعة",
    },
  },
};

export default I18N_BASE_FS_MAPPING;
